var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"videoPlayerContainer"}},[_c('div',{staticClass:"videoHeader"},[_c('van-icon',{staticClass:"closebuttton",attrs:{"name":"close"},on:{"click":_vm.close}})],1),_c('video',{attrs:{"src":_vm.videoUrl,"autoplay":"","controls":"controls","width":"100%"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }